module.exports = __webpack_public_path__ + "img/didier_lepelletier.8b368f56.jpeg";